import React, { useState, useEffect, ChangeEvent } from 'react';
import './styles.css'

import Template from '../../components/Template';
import TableUsers from '../../components/TableUsers';

export default function ListUsers() {
  return (
    <Template path={'Usuários'}>
      <div className="position-relative p-3 ">
        <TableUsers />
      </div>
    </Template>
  )
}
